import { apiFetch } from "@core/http";
import type { GrandPrize, GrandPrizeInput } from "@core/types";

const base = "/v1/portal/grand-prize";

export const listGrandPrizes = () => apiFetch<GrandPrize[]>(base);

// El contrato acepta `confirmed` además de `GrandPrizeInput` en ambas
// operaciones de escritura (openapi.d.ts: portalCreateGrandPrize/
// portalEditGrandPrize), sin declarar un tipo propio para la intersección —
// se declara acá, con la misma forma que documenta el contrato, igual patrón
// que `UserCreateInput` en features/users/api.ts.
export type GrandPrizeSaveInput = GrandPrizeInput & { confirmed?: boolean };

export const createGrandPrize = (input: GrandPrizeSaveInput) =>
  apiFetch<GrandPrize>(base, { method: "POST", body: input });

export const editGrandPrize = (id: string, input: GrandPrizeSaveInput) =>
  apiFetch<GrandPrize>(`${base}/${encodeURIComponent(id)}`, {
    method: "PUT",
    body: input,
  });

// Forma de `Problem.impact` (openapi.d.ts declara `impact?: { [key:
// string]: unknown }`, sin tipar sus campos) para las confirmaciones
// CONFIRM_IMPACT y CONFIRM_REPLACEMENT (SPEC-208 §4/§7,
// api/contracts/parts/30-prizes-redeemables.yaml:75-124). Se declara acá
// porque el contrato no lo tipa, igual criterio que `impactOf` en
// features/catalogs/CatalogsScreen.tsx.
export interface GrandPrizeImpact {
  affectedMembers?: number;
  wouldReachGoal?: number;
  wouldLoseProgress?: number;
  averageProgressLost?: number;
}
